import React from 'react';
import { Bot, Database, TrendingUp, Phone, Calendar, FileText } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { servicesData } from '../mockData';

const iconMap = {
  Bot: Bot,
  Database: Database,
  TrendingUp: TrendingUp,
  Phone: Phone,
  Calendar: Calendar,
  FileText: FileText
};

const Services = () => {
  return (
    <section id="services" className="py-24 bg-slate-50">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-blue-100 text-blue-700 hover:bg-blue-200 px-4 py-1.5 text-sm font-semibold">
            OUR SERVICES
          </Badge>
          <h2 className="text-5xl font-bold text-slate-900 mb-6">
            AI Solutions That Drive Revenue
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Powerful automation tools designed specifically for high-growth businesses. 
            Each solution integrates seamlessly to multiply your results.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesData.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-300 border-2 hover:border-blue-500 hover:-translate-y-2 bg-white"
              >
                <CardHeader>
                  <div className="mb-4 inline-flex p-4 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <IconComponent className="h-8 w-8 text-white" />
                  </div>
                  <CardTitle className="text-2xl font-bold text-slate-900 mb-2">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-slate-600 text-base leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="space-y-3">
                    <div className="font-semibold text-sm text-slate-700 mb-2">KEY FEATURES:</div>
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-start gap-2">
                        <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                        <span className="text-slate-700 text-sm">{feature}</span>
                      </div>
                    ))}
                  </div>
                  
                  <div className="mt-6 pt-4 border-t border-slate-200">
                    <div className="flex flex-wrap gap-2">
                      {service.targetAudience.map((audience, idx) => (
                        <Badge 
                          key={idx}
                          variant="outline"
                          className="text-xs bg-slate-50 border-slate-300 text-slate-700"
                        >
                          {audience}
                        </Badge>
                      ))}
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-lg text-slate-700 mb-4">
            Not sure which services you need? 
          </p>
          <a 
            href="https://calendly.com/aiasap-info/ai-asap-consultation"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block text-blue-600 hover:text-blue-700 font-semibold text-lg hover:underline transition-colors"
          >
            Get a free consultation →
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
